import { render, staticRenderFns } from "./cardStatuses.vue?vue&type=template&id=06dc4620&"
import script from "./cardStatuses.vue?vue&type=script&lang=js&"
export * from "./cardStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports